<template>
<div>
   <br>
<div>
  <v-card
    class="mx-auto"
  >
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline"><v-icon color="green">mail</v-icon>Minha caixa de Mensagens</v-list-item-title>
        <v-list-item-subtitle>Visualize as suas mensagens</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
        <template>
        <v-card>
          <v-tabs vertical>
            <v-tab>
              <v-icon left>
                mdi-account
              </v-icon>
              Caixa de Entrada <v-chip>{{mensagens.length}}</v-chip>
            </v-tab>
          <v-tab-item>
              <v-card flat style="border:1px  solid #ccc;">
                <v-card-text>
                      <v-list two-line>
                                <v-list-item-group
                                  v-model="selected"
                                  active-class="pink--text"
                                  multiple
                                >
                                  <template v-for="(item, index) in mensagens">
                                    <v-list-item :key="item.titulo" @click="LerMensagem(item)">
                                      <template v-slot:default="{ active }">
                                        <v-list-item-avatar>
                                          <v-icon v-if="!item.controleLeitura.includes(idPessoa)">mail</v-icon>
                                           <v-icon v-else>drafts</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title v-text="item.titulo"></v-list-item-title>

                                          <v-list-item-subtitle
                                            class="text--primary"
                                            v-text="item.from"
                                          ></v-list-item-subtitle>

                                          <v-list-item-subtitle v-text="item.descricao"></v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                          <v-list-item-action-text v-text="item.action"></v-list-item-action-text>

                                          <v-icon
                                            v-if="!active"
                                            color="grey lighten-1"
                                          >
                                            mdi-star-outline
                                          </v-icon>

                                          <v-icon
                                            v-else
                                            color="yellow darken-3"
                                          >
                                            mdi-star
                                          </v-icon>
                                        </v-list-item-action>
                                      </template>
                                    </v-list-item>

                                    <v-divider
                                      v-if="index < mensagens.length - 1"
                                      :key="index"
                                    ></v-divider>
                                  </template>
                                </v-list-item-group>
                              </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </template>
    </v-card-text>

  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    item: 1,
    mensagens: [],
    mensagensLidas: [],
    selected: [],
    idPessoa: ls.get('idPessoa')
  }),
  created () {
    this.InitializeMensagens()
  },
  methods: {
    async InitializeMensagens () {
      try {
        this.mensagens = await axios
          .get('/mensagemFindAll')
          .then(res => res.data)
        this.AdicionaSelecionadas()
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    LerMensagem (item) {
      ls.set('mensagem', item)
      this.$router.push('Mensagens-leitura')
    },
    AdicionaSelecionadas () {
      this.mensagens.forEach(element => {
        if (element.controleLeitura.includes(this.idPessoa)) {
          let index = this.mensagens.indexOf(element)
          this.selected.push(index)
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
